
// we should refactor to move the delete, success, and warning forms into this file
export const confirmationForm = (disclaimer, view) => {
    let form = [
        {
            type: "vertical mobile-vertical large-gap",
            fields: [
                {
                    value: (
                        <div className="confirm-container full-width">
                            <div className="disclaimer">{`${disclaimer}`}</div>
                            <div className="item">{view}</div>
                        </div>
                    )
                }
            ]
        }
    ];

    return form;
}